import restClient from '../restClient';
export const GET_FORM = 'GET_FORM';
export const RESET_FORM_CONTEXT = 'RESET_FORM_CONTEXT';
export const RESET_FORM_COMPLETION_STATUS = 'RESET_FORM_COMPLETION_STATUS';
export const FETCHING_FORM = 'FETCHING_FORM';
export const GET_FORM_FAILED = 'GET_FORM_FAILED';
export const FORM_COMPLETED = 'FORM_COMPLETED';
export const FAILED_COMPLETING_FORM = 'FAILED_COMPLETING_FORM';
export const FORM_COMPLETION_IN_PROGRESS = 'FORM_COMPLETION_IN_PROGRESS';
const doFormReset = () => ({
  type: RESET_FORM_CONTEXT
});
const doFormCompletionStatusReset = () => ({
  type: RESET_FORM_COMPLETION_STATUS
});
const doGetForm = form => ({
  form,
  type: GET_FORM
});
const fetchingForm = () => ({
  fetchingForm: true,
  type: FETCHING_FORM
});
const formCompleted = status => ({
  status,
  type: FORM_COMPLETED
});
const formCompletionInProgress = formCompletionInProgress => ({
  formCompletionInProgress,
  type: FORM_COMPLETION_IN_PROGRESS
});
const failedToCompleteForm = error => ({
  error,
  type: FAILED_COMPLETING_FORM
});
const failedToGetForm = error => ({
  error,
  type: GET_FORM_FAILED
});
export const getForm = context => async dispatch => {
  try {
    dispatch(fetchingForm());
    const form = await restClient.formV8({
      kycContext: context
    });
    dispatch(doGetForm(form));
  } catch (error) {
    dispatch(failedToGetForm(error));
  }
};
export const completeDeclaration = () => async dispatch => {
  dispatch(formCompletionInProgress(true));
  try {
    const status = await restClient.completeDeclarationV2();
    dispatch(formCompleted(status.caseStatus));
  } catch (error) {
    dispatch(failedToCompleteForm(error));
  }
};
export const resetForm = () => async dispatch => {
  dispatch(doFormReset());
  dispatch(doFormCompletionStatusReset());
};